/// Config toast (thông báo nổi góc phải trên) — đăng ký ở `main.ts`.

/**
 * Bao lâu (ms) một toast tự đóng.
 *
 * 4000 (giá trị cũ) đủ cho câu ngắn kiểu 「保存しました」, nhưng KHÔNG đủ cho các câu lỗi
 * dài — mà lỗi mới là loại toast bắt buộc phải đọc được. Ví dụ trong app này:
 * `errAccessWhitelistEmptyEnableBlocked` dài ~110 ký tự tiếng Nhật, tốc độ đọc thường
 * ~7–8 ký tự/giây nên chỉ đọc thôi đã ~15 giây; toast biến mất sau 4 giây thì người dùng
 * chỉ kịp thấy "có gì đó màu đỏ".
 *
 * Không đặt `false` (không tự đóng): mọi toast phải bấm mới tắt sẽ đọng lại thành một
 * chồng ở góc màn hình và che nội dung.
 *
 * Đây là "thời gian đọc được mà KHÔNG cần làm gì", không phải giới hạn cứng —
 * vue3-toastify mặc định `pauseOnHover: true` (trỏ chuột vào là đồng hồ dừng, đọc bao lâu
 * cũng được) và `closeOnClick: true` (bấm để tắt sớm).
 */
export const TOAST_AUTO_CLOSE_MS = 15000
